// Кабинет — способ показать должности. Проверки API остаются на сервере.
const POSITIONS = ['surveyor', 'manager', 'draftsman', 'quality_master', 'head_manager'];

export const normalizedPositions = (account) => {
    const raw = account?.position;
    const values = Array.isArray(raw) ? raw : typeof raw === 'string' ? raw.split(',') : [];
    return [...new Set(values.map((v) => String(v).trim()).filter((v) => POSITIONS.includes(v)))];
};

export const canUseManagement = (account) =>
    account?.role === 'administrator' ||
    normalizedPositions(account).some((p) => ['manager', 'head_manager'].includes(p)) ||
    (account?.role === 'manager' && normalizedPositions(account).length === 0);

export const getAvailableCabinets = (account) => {
    let result = normalizedPositions(account);
    if (account?.role === 'manager' && !result.length) {
        result.push('manager');
    }
    if (account?.role === 'administrator' && !result.length) result.push('head_manager');
    if (result.includes('draftsman')) result = result.filter((r) => r !== 'quality_master');
    const server = account?.cabinet_access;
    if (server?.version === 1 && Array.isArray(server.cabinets)) {
        const allowed = new Set(server.cabinets);
        result = result.filter((r) => allowed.has(r));
    }
    return result;
};

export const resolveCabinet = (account, storedRole) => {
    const cabinets = getAvailableCabinets(account);
    if (cabinets.includes(storedRole)) return storedRole;
    if (storedRole === 'quality_master' && cabinets.includes('draftsman')) return 'draftsman';
    return cabinets[0] || null;
};

export const hasQualitySection = (account) => {
    const positions = normalizedPositions(account);
    const local = positions.length
        ? positions.some((p) => ['quality_master', 'head_manager'].includes(p))
        : account?.role === 'administrator';
    return local && account?.cabinet_access?.quality_section !== false;
};

export const canOpenCabinetPath = (pathname, account, activeRole, allowedRoles, permission) => {
    // The event API checks the assignment and section rights. Opening its page does
    // not grant browsing access to the whole company storage.
    if (/^\/storage\/events\/[1-9]\d*\/(input|measurement|sheets|photos|drawings|published)\/?$/.test(pathname)) {
        return Boolean(account?.id && (account.role === 'administrator' || getAvailableCabinets(account).includes(activeRole)));
    }
    if (pathname === '/storage' || pathname.startsWith('/storage/')) {
        return account?.role === 'administrator' || (account?.permissions || []).includes('storage.view');
    }
    if (pathname === '/settings' || pathname.startsWith('/settings/') || pathname === '/access' || pathname.startsWith('/access/')) {
        const required = pathname === '/access' || pathname.startsWith('/access/') ? 'access.manage' : 'settings.chats.view';
        return account?.role === 'administrator' || (account?.permissions || []).includes(required);
    }
    const isQualityPath = pathname === '/quality' || pathname.startsWith('/quality/');
    if (isQualityPath && !hasQualitySection(account)) return false;
    if (account?.role === 'administrator') return true;
    if (!getAvailableCabinets(account).includes(activeRole)) return false;
    // В кабинете качества только один рабочий раздел, независимо от старого URL.
    if (activeRole === 'quality_master' && !isQualityPath) return false;
    const roleOk = isQualityPath
        ? hasQualitySection(account)
        : allowedRoles == null || allowedRoles.includes(activeRole);
    return roleOk && (!permission || (account?.permissions || []).includes(permission));
};
